import { CHANGE_MEDIA_QUERY } from '../actions/types'

import { EXTRA_SMALL_DEVICE } from '../constant'

const initialState = {
  screen: EXTRA_SMALL_DEVICE,
}

const mediaQuery = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_MEDIA_QUERY:
      return {
        ...state,
        screen: action.screen,
      }
    default:
      return state
  }
}

export default mediaQuery



// WEBPACK FOOTER //
// ./src/reducers/mediaQuery.js